import { Box, BoxProps as IBoxProps, styled } from "@mui/material";

export const PageNotFoundWrapper = styled(
  Box,
  {},
)<Partial<IBoxProps>>(() => ({
  "&.page-not-found-container": {
    height: "90vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "1.5rem",
    ".emoji": {
      width: "10rem",
      height: "10rem",
    },
    h3: {
      fontWeight: 700,
    },
    a: {
      cursor: "pointer",
      color: "blue",
    },
  },
}));
